import React from 'react'

const WardManagement = () => {
  return (
    <div>WardManagement</div>
  )
}

export default WardManagement